<template>
  <div class="form-group">
    <CustomLabel
      v-if="inputLabel"
      :inputLabel="inputLabel"
      :inputId="inputId"
      :isMandatory="isMandatory"
    />
    <el-input-number
      v-model="inputValue"
      @change="onChange"
      @blur="onBlur"
      :disabled="isDisabled"
      :min="minValue"
      :max="maxValue"
      :step="stepValue"
      :controlsPosition="controlsPosition"
      step-strictly
      :size="isTabletScreen || isSmall ? 'small' : 'default'"
    />
    <div v-if="isFormField">
      <Field v-model="inputValue" :id="inputId" :name="inputId" hidden />
      <ErrorMessage :name="inputId" class="validation-message" />
    </div>
  </div>
</template>
<script lang="ts">
import CustomLabel from "@/components/input/CustomLabel.vue";
import { useSessionStore } from "@/stores/sessionStore";
import { storeToRefs } from "pinia";
import { ErrorMessage, Field } from "vee-validate";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "CustomInputNumber",
  props: {
    inputId: { type: String, required: true },
    initialValue: { type: Number, required: false },
    stepValue: { type: Number, default: 1 },
    minValue: { type: Number, default: undefined },
    maxValue: { type: Number, default: undefined },
    inputLabel: { type: String, required: false },
    isMandatory: { type: Boolean, default: false },
    controlsPosition: { type: String, default: "" },
    isFormField: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    isSmall: { type: Boolean, default: false },
  },
  components: { CustomLabel, Field, ErrorMessage },
  setup(props, { emit }) {
    const inputValue = ref(props.initialValue);
    const sessionStore = useSessionStore();
    const { isTabletScreen } = storeToRefs(sessionStore);

    function onChange() {
      if (
        inputValue.value !== undefined &&
        (inputValue.value === null || isNaN(inputValue.value))
      ) {
        inputValue.value = 0;
      }
      emit("onChange", inputValue.value);
    }
    function onBlur() {
      emit("onBlur", inputValue.value);
    }
    return { inputValue, isTabletScreen, onChange, onBlur };
  },
});
</script>
